<template>
  <v-navigation-drawer style="background-color:#F5F5F5!important;" fixed width="260"
    :clipped="$vuetify.breakpoint.mdAndUp" break-point="768" app v-model="leftBarVis" dark>

    <v-list dense single-line class="pa-0">
      <template v-for="item in menuItems">

        <v-list-item :key="item.text" @click="gotoPage(item)" :style="{
          borderLeft: isActive(item) ? '4px solid #2196F3' : '4px solid #fff',
          color: isActive(item) ? 'primary' : '#BDBDBD'
        }">
          <v-list-item-avatar>
            <v-icon large :color="isActive(item) ? 'primary' : '#000'">{{ item.img }}</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title style="font-size:15px; color:#000;">
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>


        <v-divider color="#BDBDBD" :key="'divider_' + item.progOrder"></v-divider>

      </template>

    </v-list>

    <template v-slot:append>
      <a href="https://www.simonatunno.it/" target="_blank">
        <v-img src="https://www.simonatunno.it/images/logo-stunno.jpg" contain aspect-ratio="4.75"></v-img>
      </a>
    </template>

  </v-navigation-drawer>

</template>


<script>
export default {

  props: {
    menuItems: {
      type: Array,
    },
  },

  data: () => ({
    leftBarVis: null,
  }),

  methods: {

    esci() {
      this.$emit("esci");
    },

    gotoPage(pagina) {
      if (pagina == null || pagina.link == undefined) return;

      if (pagina.link == "@esci") this.esci();

      if (pagina.link == "/registro" && this.getRole != "admin")
        this.$router.push({ path: pagina.link + "/" + this.getRole }).catch(() => { });
      this.$router.push({ path: pagina.link }).catch(() => { });
    },

    isActive(item) {
      if (item.link === '/') {
        return this.$route.path === '/';
      }
      return this.$route.path === item.link || this.$route.path.startsWith(item.link + '/');
    },

  },

  computed: {
    getRole() {
      return this.$store.getters["user/getRole"];
    },
  }
};
</script>
